module.exports = __webpack_public_path__ + "img/missile_battery.be53fb04.jpg";